import { push } from 'react-router-redux';

let store = null;

export const setStore = (newStore) => {
  store = newStore;
};

const pushRoute = (route) => {
  if (!store) {
    return;
  }

  if (typeof route === 'string' && route.includes('?')) {
    const [pathname, queryString] = route.split('?');
    const query = {};

    new URLSearchParams(queryString).forEach((value, key) => {
      query[key] = value;
    });

    store.dispatch(push({ pathname, query }));
    return;
  }

  store.dispatch(push(route));
};

export default pushRoute;
